export function isValidDNI(value) {
  const regex = new RegExp("\\d{9}", "gm")
  const match = regex.exec(value)

  if (!match) return false

  return true
}
